module.exports = __webpack_public_path__ + "media/images/template-66c854f22939cdb542a744a99a414e06.jpg";